export default __webpack_public_path__ + "static/media/PricingCard2.c8120251.png";